let MS_IN_MINUTES = 60 * 1000;

let formatTime = function (date) {
    return date.toISOString().replace(/-|:|\.\d+/g, '');
};

let getURLGoogle = function (event) {
    let startTime = formatTime(event.start);
    let endTime = formatTime(event.end);

    return encodeURI([
        'https://www.google.com/calendar/render',
        '?action=TEMPLATE',
        '&text=' + (event.title || ''),
        '&dates=' + (startTime || ''),
        '/' + (endTime || ''),
        '&details=' + (event.description || ''),
        '&location=' + (event.address || ''),
        '&sprop=&sprop=name:'
    ].join(''));
}

let getURLYahoo = function (event) {
    let eventDuration = ((event.end.getTime() - event.start.getTime()) / MS_IN_MINUTES);

    // Yahoo dates are crazy, we need to convert the duration from minutes to hh:mm
    let yahooHourDuration = eventDuration < 600 ?
        '0' + Math.floor((eventDuration / 60)) :
        Math.floor((eventDuration / 60)) + '';

    let yahooMinuteDuration = eventDuration % 60 < 10 ?
        '0' + eventDuration % 60 :
        eventDuration % 60 + '';

    let yahooEventDuration = yahooHourDuration + yahooMinuteDuration;

    // Remove timezone from event time
    //let st = formatTime(new Date(event.start - (event.start.getTimezoneOffset() *
    //    MS_IN_MINUTES))) || '';

    let st = formatTime(event.start);

    return encodeURI([
        'http://calendar.yahoo.com/?v=60&view=d&type=20',
        '&title=' + (event.title || ''),
        '&st=' + st,
        '&dur=' + (yahooEventDuration || ''),
        '&desc=' + (event.description || ''),
        '&in_loc=' + (event.address || '')
    ].join(''));
}

let getURLICS = function (event) {
    let startTime = formatTime(event.start);
    let endTime = formatTime(event.end);

    const components = [
        "BEGIN:VCALENDAR",
        "VERSION:2.0",
        "BEGIN:VEVENT",
        //`URL:${document.URL}`,
        'DTSTART:' + (startTime || ''),
        'DTEND:' + (endTime || ''),
        'SUMMARY:' + (event.title || ''),
        'DESCRIPTION:' + (event.description || ''),
        'LOCATION:' + (event.address || ''),
        "END:VEVENT",
        "END:VCALENDAR"
    ];

    return encodeURI(`data:text/calendar;charset=utf8,${components.join("\n")}`);
}

// Make sure we have the necessary event data, such as start time and end time
let validParams = function (params) {
    return params.data !== undefined && params.data.start !== undefined && params.data.end !== undefined;
};

let getAddToCalendarURL = function (params) {
    if (!validParams(params)) {
        console.log('Event details missing.');
        return;
    }

    switch (params.type.toLowerCase()) {
        case "google":
            return getURLGoogle(params.data);
        case "yahoo":
            return getURLYahoo(params.data);
        case "outlook":
            return getURLICS(params.data);
        case "ical":
            return getURLICS(params.data);
        default:
            return "";
    }
}

export { getAddToCalendarURL }